interface LogoProps {
  variant?: 'horizontal' | 'icon'
  /**
   * 'white' — white marks, transparent background (for dark/coloured surfaces).
   *   Uses CSS invert+brightness+mix-blend-mode:screen — works on any background colour.
   * 'dark' — original dark-green-on-white PNG, no filter.
   */
  color?: 'white' | 'dark'
  className?: string
}

export function Logo({ variant = 'horizontal', color = 'white', className }: LogoProps) {
  const src = variant === 'icon' ? '/logo-icon.png' : '/logo-horizontal.png'

  if (color === 'dark') {
    return <img src={src} alt="KasaGO" className={className} draggable={false} />
  }

  // invert(1)       — dark-green brand → bright; white background → black
  // brightness(10)  — pushes all non-zero pixels past the clamp to white;
  //                   true black (inverted white bg) stays 0
  // mix-blend-mode screen — screen(black, bg) == bg, so the black rectangle
  //                   disappears and the white marks remain on any background
  return (
    <img
      src={src}
      alt="KasaGO"
      className={className}
      draggable={false}
      style={{ filter: 'invert(1) brightness(10)', mixBlendMode: 'screen' }}
    />
  )
}
